"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const RootWrapper_1 = __importDefault(require("./RootWrapper"));
const GroupWrapper_1 = __importDefault(require("./GroupWrapper"));
const TGTextHeader_1 = __importDefault(require("../FormFields/TGTextHeader"));
const TGTextField_1 = __importDefault(require("../FormFields/TGTextField"));
const TGRadioField_1 = __importDefault(require("../FormFields/TGRadioField"));
const TGDateField_1 = __importDefault(require("../FormFields/TGDateField"));
const TGSelectField_1 = __importDefault(require("../FormFields/TGSelectField"));
const TGTimeField_1 = __importDefault(require("../FormFields/TGTimeField"));
const TGLocationField_1 = __importDefault(require("../FormFields/TGLocationField/TGLocationField"));
const TGPolylineField_1 = __importDefault(require("../FormFields/TGLocationField/TGPolylineField"));
const FormHelpers_1 = require("./FormHelpers");
const WorkflowFieldWrapper_1 = __importDefault(require("./WorkflowFieldWrapper"));
const RepeatWrapper_1 = __importDefault(require("./RepeatWrapper"));
const TGImageUploadField_1 = __importDefault(require("../FormFields/TGImageUploadField"));
const TGBarCodeField_1 = __importDefault(require("../FormFields/TGBarCodeField"));
const TGMapAggregateSelectorField_1 = __importDefault(require("../FormFields/TGMapAggregateSelectorField"));
const RepeatFieldWrapper_1 = __importDefault(require("./RepeatFieldWrapper"));
const TGFileUploadField_1 = __importDefault(require("../FormFields/TGFileUploadField"));
const withNoRepeatableWorkflowFieldWrapper = (Component) => {
    return (props) => {
        const { controlDefinition } = props;
        return (react_1.default.createElement(WorkflowFieldWrapper_1.default, { controlDefinition: controlDefinition, repeatable: false },
            react_1.default.createElement(Component, Object.assign({}, props))));
    };
};
/**
 * This is a higher order component that wraps a repeatable component instance and determines its visibility based on the current context and props
 * Its main responsibility is to hide repeated elements if the repeat is collapsed
 * @param Component The UI component to wrap
 */
const withRepeatable = (Component) => {
    return (props) => {
        const { 
        // multiline, we will reuse it maybe later
        repeatable, index, repeatCount, controlDefinition, onAddClick, onRemoveClick, moveItems, isOriginal, } = props;
        return repeatable ? (react_1.default.createElement(RepeatFieldWrapper_1.default, { onAddClick: onAddClick, onRemoveClick: onRemoveClick, controlDefinition: controlDefinition, repeatable: repeatable, index: index, repeatCount: repeatCount, moveItems: moveItems, isOriginal: isOriginal },
            react_1.default.createElement(Component, Object.assign({}, props)))) : (react_1.default.createElement("div", { style: { marginBottom: 10 } },
            react_1.default.createElement(Component, Object.assign({}, props))));
    };
};
/**
 * This is a higher order component that wraps a repeatable component instance and determines its visibility based on the current context and props
 * Its main responsibility is to hide repeated elements if the repeat is collapsed
 * @param Component The UI component to wrap
 */
const withFileRepeatable = (Component) => {
    return (props) => {
        const { 
        // multiline, we will reuse it maybe later
        repeatable, index, repeatCount, controlDefinition, onAddClick, onRemoveClick, moveItems, isOriginal, } = props;
        return repeatable ? (react_1.default.createElement(RepeatFieldWrapper_1.default, { onAddClick: onAddClick, onRemoveClick: onRemoveClick, controlDefinition: controlDefinition, repeatable: repeatable, index: index, repeatCount: repeatCount, moveItems: moveItems, isOriginal: isOriginal },
            react_1.default.createElement(Component, Object.assign({}, props)))) : (react_1.default.createElement("div", { style: { marginBottom: 10 } },
            react_1.default.createElement(Component, Object.assign({}, props))));
    };
};
const ControlProvider = {
    //Can't use filterFieldProps on the textheader, because it isn't a field.
    RootWrapper: RootWrapper_1.default,
    GroupWrapper: GroupWrapper_1.default,
    RepeatWrapper: RepeatWrapper_1.default,
    textheader: withNoRepeatableWorkflowFieldWrapper((0, FormHelpers_1.withTextHeaderProps)(TGTextHeader_1.default)),
    computed: withRepeatable((0, FormHelpers_1.withTextFieldPropsComputed)(TGTextField_1.default)),
    textInput: withRepeatable((0, FormHelpers_1.withTextFieldProps)(TGTextField_1.default)),
    radio: withRepeatable((0, FormHelpers_1.withRadioFieldProps)(TGRadioField_1.default)),
    numberInput: withRepeatable((0, FormHelpers_1.withNumberFieldProps)(TGTextField_1.default)),
    select: withRepeatable((0, FormHelpers_1.withSelectFieldProps)(TGSelectField_1.default)),
    checkbox: withRepeatable((0, FormHelpers_1.withCheckboxProps)(TGSelectField_1.default)),
    time: withRepeatable((0, FormHelpers_1.withTimeFieldProps)(TGTimeField_1.default)),
    date: withRepeatable((0, FormHelpers_1.withDateFieldProps)(TGDateField_1.default)),
    textArea: withRepeatable((0, FormHelpers_1.withTextareaFieldProps)(TGTextField_1.default)),
    currency: withRepeatable((0, FormHelpers_1.withCurrencyFieldProps)(TGTextField_1.default)),
    imageupload: withRepeatable((0, FormHelpers_1.withMediaFieldProps)(TGImageUploadField_1.default)),
    fileupload: withRepeatable((0, FormHelpers_1.withFileFieldProps)(TGFileUploadField_1.default)),
    barcode: withRepeatable((0, FormHelpers_1.withBarcodeFieldProps)(TGBarCodeField_1.default)),
    location: withRepeatable((0, FormHelpers_1.withLocationFieldProps)(TGLocationField_1.default)),
    floorPlanLocation: withRepeatable((0, FormHelpers_1.withLocationFieldProps)(TGLocationField_1.default)),
    polyline: withRepeatable((0, FormHelpers_1.withPolylineFieldProps)(TGPolylineField_1.default)),
    mapAggregateSelector: withRepeatable((0, FormHelpers_1.withAggregateSelectorFieldProps)(TGMapAggregateSelectorField_1.default)),
};
exports.default = ControlProvider;
//# sourceMappingURL=ControlProvider.js.map